import { Box, CircularProgress } from "@mui/material";
import { iresoftColors } from "../../../theme/ireColors";

const FullPageSpinner = () => {
  return (
    <Box
      role="alert"
      aria-live="assertive"
      aria-busy="true"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "#f2f2f2",
        zIndex: 1000,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "none",
          }}
        >
          <CircularProgress
            size={48}
            aria-label="Loading"
            sx={{ color: iresoftColors.iresoftRed }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default FullPageSpinner;
